import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class CheckoutPiggyResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("CheckoutPiggyResourcePackage");
    }
    public get assets_views_piggy_intro_piggy_intro_0_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/piggy_intro/piggy_intro-0_1x.atlas.json");
    }
    public get assets_views_piggy_intro_tocken_background_png(): Texture {
        return this.assets_views_piggy_intro_piggy_intro_0_1x_atlas_json.textures["tocken_background.png"];
    }
    public get assets_views_piggy_intro_big_piggy_png(): Texture {
        return this.assets_views_piggy_intro_piggy_intro_0_1x_atlas_json.textures["big_piggy.png"];
    }
    public get assets_views_piggy_intro_welcome_png(): Texture {
        return this.assets_views_piggy_intro_piggy_intro_0_1x_atlas_json.textures["welcome.png"];
    }
    public get assets_views_piggy_intro_blue_light_vertical_png(): Texture {
        return this.assets_views_piggy_intro_piggy_intro_0_1x_atlas_json.textures["blue_light_vertical.png"];
    }
    public get assets_views_piggy_intro_piggy_png(): Texture {
        return this.assets_views_piggy_intro_piggy_intro_0_1x_atlas_json.textures["piggy.png"];
    }
    public get assets_views_piggy_intro_token_png(): Texture {
        return this.assets_views_piggy_intro_piggy_intro_0_1x_atlas_json.textures["token.png"];
    }
    public get assets_views_piggy_intro_piggy_intro_0_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/piggy_intro/piggy_intro-0_1x.atlas.png");
    }
    public get assets_views_piggy_intro_piggy_intro_1_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/piggy_intro/piggy_intro-1_1x.atlas.json");
    }
    public get assets_views_piggy_intro_blue_light_top_png(): Texture {
        return this.assets_views_piggy_intro_piggy_intro_1_1x_atlas_json.textures["blue_light_top.png"];
    }
    public get assets_views_piggy_intro_blue_light_bottom_png(): Texture {
        return this.assets_views_piggy_intro_piggy_intro_1_1x_atlas_json.textures["blue_light_bottom.png"];
    }
    public get assets_views_piggy_intro_piggy_intro_1_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/piggy_intro/piggy_intro-1_1x.atlas.png");
    }
}

